import { Injectable } from "@angular/core";
import { LocalStorageService } from "@core/services/storage/local-storage.service";
import { Business, BusinessPadrao } from "@data/schemas/business";
import { DataList } from "@data/schemas/filter/data-list";
import { BaseCrudBffService } from "@shared/services/base-crud-bff.service";
import { BaseCrudService } from "@shared/services/base-crud.service";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root"
})
export class BusinessService {
	private readonly BUSINESSES_ENDPOINT = "businesses";

	constructor(
		private data: BaseCrudService,
		private baseCrudBff: BaseCrudBffService,
		private localStorage: LocalStorageService
	) {}

	searchBusinessAutoComplete(
		searchText: string
	): Observable<DataList<Business>> {
		return this.data.getAutoComplete(
			`${this.BUSINESSES_ENDPOINT}/auto-complete-business/`,
			searchText
		);
	}

	getBusinessDefault(): Observable<BusinessPadrao> {
		return this.baseCrudBff.getAll({
			path: "business-default"
		});
	}

	getBusinessData(): BusinessPadrao | null {
		return this.localStorage.get<BusinessPadrao>("businessPadrao");
	}

	setBusinessData(business: BusinessPadrao): void {
		this.localStorage.set("businessPadrao", business);
	}

	clearBusinessData(): void {
		this.localStorage.remove("businessPadrao");
	}
}
